import { render } from "./page12.vue?vue&type=template&id=0e292ea0&scoped=true"
import script from "./page12.vue?vue&type=script&lang=js"
export * from "./page12.vue?vue&type=script&lang=js"

import "./page12.vue?vue&type=style&index=0&id=0e292ea0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e292ea0"]])

export default __exports__